module.exports = __webpack_public_path__ + "vc.svg?fc6aa8fea6b1679f5618d420705c9fdf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/vc.svg
// module id = 1427
// module chunks = 0